export enum UserStatusEnum {
  CONFIRMED = "CONFIRMED",
  UNCONFIRMED = "UNCONFIRMED",
  EXTERNAL_PROVIDER = "EXTERNAL_PROVIDER",
  FORCE_CHANGE_PASSWORD = "FORCE_CHANGE_PASSWORD",
  RESET_REQUIRED = "FORCE_CHANGE_PASSWORD",
}

export enum ActionEnum {
  search = "SEARCH",
  setNewPassword = "SET_NEW_PASSWORD",
}
